// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ReactDocx_errorText__2qo9X","pendingMessage":"ReactDocx_pendingMessage__1e3yH","buttonWrapper":"ReactDocx_buttonWrapper__ISAmd"};